import Utilities from "../utilities/utilities";

export default class videoModalAutoplay {
	/**
	 * @param {Object} options - User options
	 */
	constructor(options) {
		window.addEventListener("DOMContentLoaded", () => {
			this.init();
		});

		window.addEventListener("NAVIGATE_IN", () => {
			this.init();
		});

		window.addEventListener("infiniteScrollAppended", () => {
			this.init();
		});
	}

	init() {
		var elName = ".js-video-modal-autoplay";
		var elClose = ".js-close-video-modal-autoplay";

		var $el = jQuery(elName);

		if ($el.length == 0) {
			return;
		}

		if (Utilities.getCookie("cookie-video-modal-autoplay")) {
			jQuery(elName).remove();
		}

		jQuery(elClose).on("click", function (e) {
			if (
				jQuery(elClose).hasClass("js-video-modal-autoplay-set-cookie")
			) {
				Utilities.setCookie(
					"cookie-video-modal-autoplay",
					"active",
					"0.041"
				);
			}

			jQuery(elName).remove();
		});
	}
}
